export default {
  cta: "Let's start producing",
  title: "Overview of operations",
  leftTitle: "Hurray!",
  leftSubtitle: "Let's proceed with these 3 operations."
};
